import { IStackTokens, Stack, Image, ImageFit, Label, FontIcon } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../../styles/pokemon.module.scss';
import { TProduct, TSize } from '../../constants/types';
import { GetCard, GetProduct } from '../../services/DBConnect';
import { ProcessProducts } from '../../helpers/General';
import { AlertButtonComponent } from '../../components/alertButtonComponent';
import PulseLabelv2 from '../../components/pulseLabelv2Component';
import { NavLink } from 'react-router-dom';
import GlobalContext from '../../_contexts/GlobalContext';

export interface IProductViewerComponentProps {
    allProducts: TProduct[];
    windowSize: TSize;
    onBuyClick: Function;
    EurPrice: number;
    SatPrice: number;
    AlertCoachmarkVisible: boolean;
    SetSelectedProductForAlert?: Function;
    onImageClick: Function;
    ShowToast: Function;
    SetSelectedSet?: Function;
}

const ProductViewerComponent: React.FunctionComponent<IProductViewerComponentProps> = (props: IProductViewerComponentProps) => {
    const [product, setproduct] = useState<TProduct>();
    const [added, setadded] = useState<boolean>();
    const [notAdded, setnotAdded] = useState<boolean>();

    const { SetToastMessage, Strings, BitcoinEnabled, DevEnabled, GlobalImagesVersion } = useContext(GlobalContext);

    useEffect(() => {
        const pathName = decodeURI(window.location.pathname);
        const prodName = pathName.substring(1, pathName.length);
        if (prodName.indexOf('/') === -1) {
            let filtered = props.allProducts.filter(b => b.title === prodName);
            if (filtered.length === 1) {
                setproduct(filtered[0]);
            } else {
                setproduct(null);

                GetProduct(null, prodName).then((product: TProduct) => {
                    setproduct(ProcessProducts([product])[0]);
                });
            }
        } else {
            const parts = prodName.split('/');
            const type = parts[0];
            if (type.toLowerCase() === "pokemon kaart") {
                let [setname, cardname, cardnumber, setammount, version] = (parts[1] + " - " + parts[2]).split(" - ");
                GetCard(setname, cardnumber, version, DevEnabled).then(cards => {
                    cards.forEach(card => {
                        if (version === card.version) {
                            if (card.number > 99) {
                                card.scardnumber = `${card.number}`;
                            } else if (card.number > 9) {
                                card.scardnumber = `0${card.number}`;
                            } else {
                                card.scardnumber = `00${card.number}`;
                            }
                            card.scardnumber += `/${card.size}`;

                            //TODO: move to backend, minimale prijs toevoegen
                            card.priceInUSD = Math.round(card.priceInUSD * 100) / 100;
                            card.cost = Math.round(card.priceInUSD / props.SatPrice);
                            card.scost = `${card.cost}`;
                            let imageUrls: string[] = [];
                            card.imageNames.split(',').forEach(imageName => {
                                imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/${card.setID}/${card.number.toString()}/${imageName}?v=1`);
                            });
                            imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/cardback.webp?v=${GlobalImagesVersion}`);
                            card.imageUrls = imageUrls;
                            setproduct(card);
                        }
                    });
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    }, []);

    function tryAddToChart(card: TProduct) {
        let done = false;
        if (card.available > 0) {
            done = props.onBuyClick(card);
        }
        if (done) {
            setadded(true);
            setTimeout(() => {
                setadded(false);
            }, 500);
        } else {
            SetToastMessage("Niet meer beschikbaar");
            setnotAdded(true);
            setTimeout(() => {
                setnotAdded(false);
            }, 500);
        }
    }

    function SetSelectedSet() {
        props.SetSelectedSet(product.setID);
    }

    return (
        product &&
        <div className={`${styles.mainDiv} `} style={{ maxWidth: "100%", paddingLeft: 10, overflow: "hidden", marginRight: 5 }} >
            <Stack horizontalAlign='start' horizontal={window.innerWidth > 650 ? true : false}>
                <Stack className={styles.sPanel} style={{ marginRight: window.innerWidth > 650 ? 4 : 0 }}
                    horizontalAlign={window.innerWidth > 650 ? 'start' : 'center'}
                    onClick={() => { props.onImageClick(product.imageUrls[0]); }} >
                    <Image className={styles.singleImage}
                        style={{ cursor: "default" }}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = `${process.env.PUBLIC_URL}${product.imageUrls[0]}`
                        }}
                        src={`${process.env.PUBLIC_URL}${product.imageUrls[0]}`.replace(".webp", ".png")}
                    />
                </Stack>
                <Stack style={{width:"100%"}}>
                    <Stack className={styles.sPanel} horizontal horizontalAlign='center' style={{backgroundColor:'aliceblue'}}>
                        <span style={{ fontSize: "x-large", marginTop: 10, color: "black", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{product.title}</span>
                    </Stack>
                    <div style={{ width: "100%", paddingBottom: 5, paddingTop: 5 }}>
                        <Stack>
                            <NavLink to={"/Pokemon Kaarten/" + product.name}>
                                <Stack className={styles.aPanel} onClick={SetSelectedSet} horizontalAlign='center' style={{ paddingBottom: 20 }}>
                                    <Image className={styles.setLogoMenuSingle} src={process.env.PUBLIC_URL + `/assets/pokemon/${product.setID.toString()}/${product.setID.toString()}.webp`} alt={product.name} />
                                    <Label style={{ textDecoration: "none" }}>Ga naar set</Label>
                                </Stack>
                            </NavLink>
                        </Stack>
                    </div>
                    <div className={`${styles.divTable}, ${styles.sPanel}`} style={{ verticalAlign: 'start', width: "100%", height: "100%", whiteSpace: "nowrap" }}>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell}>
                                <b><span className={styles.viewerspan}>&nbsp;Nummer</span></b>
                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>

                            </div>
                            <div className={styles.divTableCell}>
                                <span className={styles.generalspanSingle}>{product.scardnumber}</span>
                            </div>
                            <div className={styles.divTableCell} style={{ width: "100%" }}>

                            </div>
                        </div>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell}>
                                <span className={styles.viewerspan}>&nbsp;Zeldzaamheid</span>
                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>

                            </div>
                            <div className={styles.divTableCell}>
                                <span className={styles.generalspanSingle}>{product.rarety}</span>
                            </div>
                            <div className={styles.divTableCell} style={{ width: "100%" }}>

                            </div>
                        </div>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell}>
                                <span className={styles.viewerspan}>&nbsp;Versie</span>
                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>

                            </div>
                            <div className={styles.divTableCell}>
                                <span className={styles.generalspanSingle}>{product.version}</span>
                            </div>
                            <div className={styles.divTableCell} style={{ width: "100%" }}>

                            </div>
                        </div>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell}>
                                <span className={styles.viewerspan}>&nbsp;Beschikbaar</span>
                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>

                            </div>
                            <div className={styles.divTableCell}>
                                {product.available === 0 ?
                                    <span style={{ margin: 0, color: "red" }}>Uitverkocht</span>
                                    : product.available > 5 ?
                                        <Label style={{ margin: 0, color: "rgb(70, 65, 65)" }}>Nog {">"} 5</Label>
                                        : <span style={{ margin: 0, color: "red" }}>{"<"} 5</span>}
                            </div>
                            <div className={styles.divTableCell} style={{ width: "100%" }}>

                            </div>
                        </div>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell}>
                                <span className={styles.generalspanSingle}>{product.description}</span>
                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>

                            </div>
                            <div className={styles.divTableCell}>
                                <div className={styles.divTable} style={{ width: "max-content" }}>
                                    {product.tags?.map(tag => {
                                        return <div className={styles.divTableRow}>
                                            <div className={styles.divTableCell}>
                                                <Label><b>{tag.title}</b></Label>
                                            </div>
                                            <div className={styles.divTableCell}>
                                                <Label>&nbsp;&nbsp;{tag.value}</Label>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                            <div className={styles.divTableCell} style={{ width: "100%" }}>

                            </div>
                        </div>
                    </div>
                    
                    <div className={`${styles.divTable}, ${styles.sPanel}`} style={{ backgroundColor: 'aliceblue', verticalAlign: 'start', width: "100%", whiteSpace: "nowrap" }}>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell} style={{ width: "100%" }}>

                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10, verticalAlign: "middle" }}>
                                <Stack style={{ paddingTop: 1 }} verticalAlign='center' horizontal>
                                    {BitcoinEnabled && <Stack horizontal>
                                        <Image className={styles.btcicon}
                                            style={{ cursor: "default" }}
                                            src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                                        />
                                        <PulseLabelv2 style={{ color: 'rgb(70, 65, 65)' }} text={`${product.priceInUSD === 0 ? "-" : Math.round(product.priceInUSD / props.SatPrice)} sats`} />
                                    </Stack>}
                                
                                    <PulseLabelv2 style={{ paddingRight:10, color: 'rgb(70, 65, 65)' }} text={`€ ${product.priceInUSD === 0 ? "-" : parseFloat((product.priceInUSD * props.EurPrice).toString()).toFixed(2)}`} />
                                    {product.priceInUSD != 0 && product.available > 0 ?
                                        <FontIcon style={{ width: 100, height: "100%", fontSize: 25, backgroundColor: "#30a7d7" }}
                                            aria-label={Strings.AddToCart}
                                            onClick={() => { tryAddToChart(product); }}
                                            className={`${styles.buyButtonSingle} ${added ? styles.added : notAdded ? styles.notAdded : ""}`}
                                            iconName={added ? "ShoppingCartSolid" : "ShoppingCart"} />
                                        :
                                        <AlertButtonComponent Visible={props.AlertCoachmarkVisible} OnClick={() => { props.SetSelectedProductForAlert(product); }} />
                                    }
                                </Stack>
                            </div>
                        </div>
                    </div>
                </Stack>
            </Stack>
        </div>
    );
}

export default ProductViewerComponent;